const Search = () => {
    return (
        <div>
            <span className="pageTitle">Trending</span>
        </div>
    )
}

export default Search
